import { addDays, format } from "date-fns";

export const formatBillPeriod = (
  fromDttm: string | undefined | null,
  toDttm: string | undefined | null,
) => {
  return fromDttm != null && toDttm != null
    ? `${format(new Date(fromDttm), "dd/MM/yyyy")} to ${format(
        addDays(new Date(toDttm), -1), // End date of bill period is displayed as an inclusive date
        "dd/MM/yyyy",
      )}`
    : "";
};
